import { inject } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, Observable, take } from 'rxjs';

const STORAGE_KEY = 'auth.redirectUrl';

export const isAuthenticated = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const oidcService = inject(OidcSecurityService);
  const router = inject(Router);

  return oidcService.checkAuth().pipe(
    map(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        sessionStorage.setItem(STORAGE_KEY, state.url);
        oidcService.authorize();
        return false;
      }
      
      return true;
    })
  )
};
